<template>
  <div v-if="organisation">
    <c-card>
      <c-card-body>
        <h1>{{ organisation.name }}</h1>
      </c-card-body>
    </c-card>

    <c-tabs class="kb-tabs" active>
      <c-tab title="Billing">
        <billing :organisation="organisation" />
      </c-tab>
      <c-tab title="Users">
        <div class="p-3">
          <div v-if="users.length" class="tile is-ancestor">
            <c-row>
              <c-col>
                <c-input v-model="filterUsers" style="width: 300px" type="text" placeholder="Find a user">
                  <template #append>
                    <c-button v-show="filterUsers" type="submit" color="primary" @click="clearSearch">Clear</c-button>
                  </template>
                </c-input>
              </c-col>
              <c-col>
                <c-button color="primary" class="float-right" @click="showNewUser = true">Add user</c-button>
              </c-col>
            </c-row>
            <table class="table">
              <thead>
                <tr>
                  <th>Name</th>
                  <!--<th>Position</th>-->
                  <th>Role</th>
                  <th>Email</th>
                  <th class="text-center">Account confirmed</th>
                  <th class="text-center">Allow login</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="user in users" v-if="!filterUsers || (filterUsers && findUsers(user))">
                  <td>
                    <router-link :to="{ name: 'detailsUser', params: { userId: user._id } }">
                      {{ user | showFullName }}
                    </router-link>
                  </td>
                  <!--<td>{{ user.position }}</td>-->
                  <td>{{ user.role }}</td>
                  <td>{{ user.username }}</td>
                  <td class="text-center">{{ user.accountConfirmed ? 'Yes' : 'No' }}</td>
                  <td class="text-center">{{ user.allowLogin ? 'Yes' : 'No' }}</td>
                </tr>
              </tbody>
            </table>
            <new-user :organisation="organisation" :show="showNewUser" @close="showNewUser = false" @added="added" />
          </div>
          <div v-else>
            <div>
              <p class="lead">There are no users in this organisation.</p>
            </div>
          </div>
        </div>
      </c-tab>
      <c-tab title="Groups" v-if="$store.state.app.authenticatedUser.organisation.name.indexOf('Aspen') !== -1">
        <groups :organisation="organisation" />
      </c-tab>
      <c-tab title="Reports">
        <email :organisation="organisation" />
      </c-tab>
<!--      Disable this for now -->
<!--      <c-tab title="Backup">-->
<!--        <backup :organisation="organisation" />-->
<!--      </c-tab>-->
      <c-tab title="Integrations">
        <integrations :organisation="organisation" />
      </c-tab>
    </c-tabs>
  </div>
</template>

<script>
import _ from 'lodash';
import Email from './email/side-tabs';
import Billing from './billing/side-tabs';
import Groups from './groups';
import { buildEndpoint } from '@/libs/buildEndPoint';
import NewUser from '@/views/organisation/newUser';
import Backup from '@/views/organisation/backup';
import Integrations from './integrations/side-tabs';

export default {
  name: 'OrganisationDetail',
  components: {
    NewUser,
    Email,
    Groups,
    Billing,
    Backup,
    Integrations,
  },
  data() {
    return {
      showNewUser: false,
      organisation: null,
      users: [],
      roles: [],
      filterUsers: null,
    };
  },
  mounted() {
    this.get();
    this.roles = this.$store.state.app.clientRoles;
  },
  methods: {
    clearSearch() {
      this.filterUsers = null;
    },
    findUsers(user) {
      const searchStr = user.firstName.toLowerCase()
        + (user.middleName ? user.middleName.toLowerCase() : '')
        + user.lastName.toLowerCase();
      return searchStr.indexOf(this.filterUsers) !== -1;
    },
    added() {
      // Odd, have to add a short timeout, otherwise, new user modal pops up again. Some mutation issue.
      setTimeout(() => {
        this.get();
      }, 1000);
    },
    get() {
      this.users = [];
      this.$http
        .get(buildEndpoint('organisation/get'))
        .then((response) => {
          const _this = this;
          if (response.data.success) {
            this.organisation = response.data.data.organisation;
            // Set pretty user role name
            response.data.data.users.forEach((user) => {
              const rolePretty = _.find(_this.roles, { key: user.role });
              if (rolePretty) {
                user.role = rolePretty.name;
              }
              _this.users.push(user);
            });
          } else {
            this.$store.commit('addErrorMessage', {
              header: 'Error',
              message: response.data.message,
            });
          }
        })
        .catch((error) => {
          this.$store.commit('addErrorMessage', {
            header: 'Error',
            message: error,
          });
        });
    },
  },
};
</script>
